import { UserSessionContext } from 'components/UserSession';
import { selectLocale } from 'models/localization';
import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

export const nameByLocale = (first: string, last: string, locale: string, fallback?: string) => {
  switch (locale) {
    case 'ja':
      return `${last} ${first}`.trim();
    case 'zh-Hans':
    case 'zh-Hant':
      return `${last}${first}`.trim();
    default:
      return fallback ?? `${first} ${last}`.trim();
  }
};

const useNameByLocale = () => {
  const {
    userSession: {
      lastName: last = '',
      firstName: first = '',
    },
  } = useContext(UserSessionContext);
  const locale = useSelector(selectLocale);
  return nameByLocale(first, last, locale);
};

export default useNameByLocale;
